/* Brannforge film dialog. Click-to-play only: nothing downloads until asked. */
(() => {
  const openFilm = (dialog, opener) => {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    dialog.bfOpener = opener;
    dialog.showModal();
    const video = dialog.querySelector('video');
    if (video) {
      video.preload = 'auto';
      const playback = video.play();
      if (playback && typeof playback.catch === 'function') playback.catch(() => {});
    }
  };

  const closeFilm = (dialog) => {
    if (!dialog) return;
    const video = dialog.querySelector('video');
    if (video) video.pause();
    if (dialog.open) dialog.close();
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-bf-film-open]');
    if (opener) {
      event.preventDefault();
      openFilm(document.getElementById(opener.dataset.bfFilmOpen), opener);
      return;
    }
    const closer = event.target.closest('[data-bf-film-close]');
    if (closer) {
      closeFilm(closer.closest('dialog'));
      return;
    }
    // Click on the backdrop (the dialog element itself, outside its content).
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('bf-film')) {
      closeFilm(event.target);
    }
  });

  document.addEventListener(
    'close',
    (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.classList.contains('bf-film')) return;
      const video = dialog.querySelector('video');
      if (video) video.pause();
      if (dialog.bfOpener && dialog.bfOpener.isConnected) dialog.bfOpener.focus();
    },
    true
  );
})();
